import { render, staticRenderFns } from "./guide-header-bg.vue?vue&type=template&id=f4543200&scoped=true&"
var script = {}
import style0 from "./guide-header-bg.vue?vue&type=style&index=0&id=f4543200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4543200",
  null
  
)

export default component.exports